import React from 'react';
import { Box, Typography, Button, Chip, CircularProgress } from '@mui/material';
import { EntityDrawer } from '../../ui';

// History is append-only: "Restore" only pre-fills the editor with that
// version's snapshot; the operator still reviews and saves a NEW version.
const PlanVersionsDrawer = ({ open, onClose, versions, loading, currentVersion, onRestore, t }) => (
  <EntityDrawer
    open={open}
    onClose={onClose}
    title={t('Version history', { defaultValue: 'Version history' })}
    subtitle={t('Every save is kept. Restoring creates a new version.', { defaultValue: 'Every save is kept. Restoring creates a new version.' })}
    closeLabel={t('Close', { defaultValue: 'Close' })}
    cancelLabel={t('Close', { defaultValue: 'Close' })}
    primaryLabel={t('Close', { defaultValue: 'Close' })}
    onPrimary={onClose}
  >
    {loading && <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}><CircularProgress size={22} /></Box>}
    {!loading && versions.map((v) => (
      <Box key={v.version} sx={{ py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }} data-testid={`version-${v.version}`}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle2">v{v.version}</Typography>
          {v.version === currentVersion && <Chip size="small" color="primary" label={t('Current', { defaultValue: 'Current' })} />}
          <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
            {v.changedAt ? new Date(v.changedAt).toLocaleString() : ''}{v.changedBy ? ` · ${v.changedBy}` : ''}
          </Typography>
        </Box>
        <Box component="ul" sx={{ pl: 2, my: 0.5 }}>
          {(v.changeSummary || []).map((line) => <Typography component="li" variant="body2" key={line}>{line}</Typography>)}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="caption" color="text.secondary">
            {t('{{count}} companies affected', { count: v.affectedCompanies, defaultValue: `${v.affectedCompanies} companies affected` })}
          </Typography>
          {v.version !== currentVersion && (
            <Button size="small" variant="text" sx={{ ml: 'auto' }} onClick={() => onRestore(v)}>
              {t('Restore as new version', { defaultValue: 'Restore as new version' })}
            </Button>
          )}
        </Box>
      </Box>
    ))}
  </EntityDrawer>
);

export default PlanVersionsDrawer;
